module.exports = __webpack_public_path__ + "img/practicas-en-empresas.49702671.jpg";